"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDetectElementChange = void 0;
var _react = require("react");
var useDetectElementChange = exports.useDetectElementChange = function useDetectElementChange(_ref) {
  var element = _ref.element,
    callback = _ref.callback;
  (0, _react.useEffect)(function () {
    if (!callback || !element) {
      return;
    }
    var mutationObserver = new MutationObserver(callback);
    mutationObserver.observe(element, {
      characterData: true,
      childList: true,
      subtree: true
    });
    var resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(callback);
      resizeObserver.observe(element);
    }
    return function () {
      var _resizeObserver;
      mutationObserver.disconnect();
      (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.disconnect();
    };
  }, [callback, element]);
};
//# sourceMappingURL=useDetectElementChange.js.map